<template>
  <div class="app-container mt-5">
    <div class="page-title mb-3">
      <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
      </router-link>
      <v-icon>keyboard_arrow_right</v-icon>
      <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">request_quote</v-icon> Mon outil de facturation d'adhésion
            </span>
    </div>

    <v-card class="p-2 mb-5">
      <v-card-text>
        <h4 class="mb-5">Titre des factures</h4>

        <v-text-field
          outlined
          v-model="invoiceTitle"
          hide-details
          class="mr-2"
          :class="{'input-error': invoiceTitle === ''}"
        ></v-text-field>
        <span class="text-danger" v-if="invoiceTitle === ''">Le titre des factures est manquant.</span>
      </v-card-text>
    </v-card>

    <v-card class="p-2 mb-5">
      <v-card-text>
        <h4 class="mb-5">Numéro de facture</h4>

        <v-alert text class="mb-5 mt-5" type="info">
          Pour générer un numéro de facture, vous pouvez utiliser les tags suivants
          :<br>
          <b>%jour%</b> : le jour actuel<br>
          <b>%mois%</b> : le mois actuel<br>
          <b>%annee%</b> : l'année actuelle<br>
          <b>%increment%</b> : un nombre incrémenté à chaque facture <b>(obligatoire)</b>
        </v-alert>

        <div class="d-sm-flex flex-sm-row justify-content-around">
          <div class="w-50">
            <v-text-field
              outlined
              v-model="invoicePattern"
              hide-details
              @input="generateInvoicePatternExample"
              class="mr-2"
              :class="{'input-error': incrementMissing}"
            ></v-text-field>
            <span class="text-danger" v-if="incrementMissing">Le tag %increment% est obligatoire</span>
          </div>

          <div class="w-50">
            <v-text-field
              outlined
              v-model="invoicePatternExample"
              label="Exemple de numéro de facture"
              hide-details
              disabled
              class="ml-2"
            ></v-text-field>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-card class="p-2 mb-5 d-sm-flex flex-sm-row justify-content-around">
      <div>
        <div class="valid-button">
          <h4 class="mb-5">Contact de facturation de l'Office<br> de Tourisme</h4>
          <div class="text-left mt-5">
            <v-text-field
              label="Nom"
              v-model="contactName"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Prénom"
              v-model="contactFirstName"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Téléphone"
              v-model="contactPhone"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Email"
              v-model="contactEmail"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>
        </div>
      </div>

      <div>
        <div class="valid-button">
          <h4 class="mb-5">Informations de l'Office de Tourisme</h4>
          <div class="text-left mt-5">
            <v-text-field
              label="Nom"
              v-model="ticName"
              class="mb-4 required-label"
              :class="{'input-error': ticName === '' && accountInvoice !== null}"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Adresse"
              v-model="ticAddress"
              class="mb-4 required-label"
              :class="{'input-error': ticAddress === '' && accountInvoice !== null}"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Code postal"
              v-model="ticPostalCode"
              class="mb-4 required-label"
              :class="{'input-error': ticPostalCode === '' && accountInvoice !== null}"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Ville"
              v-model="ticCity"
              class="mb-4 required-label"
              :class="{'input-error': ticCity === '' && accountInvoice !== null}"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Téléphone"
              v-model="ticPhone"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Siret"
              v-model="ticSiret"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>
        </div>
      </div>

      <div>
        <div class="valid-button">
          <h4 class="mb-5">Paiement</h4>
          <div class="text-left mt-5">
            <v-text-field
              label="IBAN"
              v-model="iban"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="BIC"
              v-model="bic"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Délai de paiement (en jour)"
              v-model="paiementDeadline"
              class="mb-4"
              hide-details
              outlined
              type="number"
              min="0"
              step="1">
            </v-text-field>
          </div>
        </div>
        <div class="valid-button">
          <h4 class="mb-5">TVA</h4>

          <div class="mt-5">
            <div v-if="!vatUsed">
              <v-icon class="mr-2">check_box_outline_blank</v-icon>Assujetti
            </div>
            <div v-else>
              <v-icon class="mr-2" color="primary">check_box</v-icon><span>Assujetti</span>
            </div>

<!--            <v-checkbox v-model="vatUsed" label="Assujetti" hide-details @change="setVatValue()"-->
<!--                        style="padding-top: 0 !important;" class="mr-3 mt-0 pt-0">-->
<!--            </v-checkbox>-->

          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Numéro TVA"
              v-model="vatNumber"
              :disabled="!vatUsed"
              class="mb-4"
              hide-details
              outlined>
            </v-text-field>
          </div>

          <div class="text-left mt-5">
            <v-text-field
              label="Taux Tva (%)"
              v-model="vatValue"
              disabled
              class="mb-4"
              type="number"
              min="0"
              hide-details
              :class="{'input-error': vatUsed && vatValue === ''}"
              outlined>
            </v-text-field>
            <span class="text-danger" v-if="vatUsed && vatValue === ''">
              Vous avez indiqué être assujetti à la TVA <br> mais vous n'avez pas spécifié de taux.
            </span>
          </div>
        </div>
      </div>
    </v-card>

    <v-card class="p-2 mb-5">
      <v-card-text>
        <h4 class="mb-5">Espace textes</h4>

        <div class="text-left mt-5">
          <h5><span>Champ textuel libre</span></h5>
          <v-textarea class="textarea" outlined v-model="invoiceSpace"></v-textarea>
        </div>

        <div class="text-left mt-5">
          <h5><span>Conditions de paiement et mentions particulières</span></h5>
          <v-textarea class="textarea" outlined v-model="invoiceConditions"></v-textarea>
        </div>
      </v-card-text>
    </v-card>

    <div>
      <embed style="width: 100vw; height: 100vh" :src="pdf" />
    </div>

    <div class="d-flex flex-row-reverse">
      <div class="text-right mb-10 ml-2" v-if="accountInvoice === null">
        <v-btn
          class="default-button mt-3"
          @click="prepareSaveConfig()"
        >
          <v-icon>save</v-icon>
          Enregistrer tout
        </v-btn>
      </div>

      <div class="text-right mb-10 ml-2" v-else>
        <v-btn
          class="default-button mt-3"
          @click="saveConfig"
          :disabled="!requiredFieldsMissing"
        >
          <v-icon>save</v-icon>
          Enregistrer tout
        </v-btn>
      </div>

      <div v-if="account.cadh_account_invoice" class="mb-10">
        <v-tooltip slot="append-outer" bottom>
          <template v-slot:activator="{ on }">
            <a class="mt-2" target="_blank" :href="apiUrl + '/invoice-preview/' + account.id">
              <v-btn class="custom-button-primary mt-3" outlined v-on="on">
                <v-icon class="mr-2">remove_red_eye</v-icon>
                Voir un exemple de facture
              </v-btn>
            </a>
          </template>
          <span>Pour visualiser vos modifications dans la facture, pensez à les enregistrer.</span>
        </v-tooltip>
      </div>

      <div v-else class="mb-10">
        <v-tooltip slot="append-outer" bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <a class="mt-2" target="_blank" :href="apiUrl + '/invoice-preview/' + account.id">
              <v-btn class="custom-button-primary mt-3" outlined :disabled="!saved || accountInvoice === null">
                <v-icon class="mr-2">remove_red_eye</v-icon>
                Voir un exemple de facture
              </v-btn>
              </a>
            </div>
          </template>
          <span v-if="!saved || accountInvoice === null">Configurez votre outil pour voir un exemple de facture.</span>
          <span v-else>Pour visualiser vos modifications dans la facture, pensez à les enregistrer.</span>
        </v-tooltip>
      </div>
    </div>

    <v-dialog ref="dialog" v-model="firstConfigMissingFieldsModal" width="400px">
      <v-card>
        <v-card-title>
          <h3 class="mb-4">Des champs obligatoires <br> sont manquants</h3>
        </v-card-title>

        <v-card-text>
          Pour enregistrer votre configuration vous devez renseigner les informations de votre Office du Tourisme.
        </v-card-text>

        <v-card-actions class="w-100 px-6 d-flex justify-content-end">
          <v-btn color="error" @click="firstConfigMissingFieldsModal = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm ref="confirm"></confirm>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Confirm from "@/components/tools/Confirm.vue"
import _ from "lodash"

export default {
  name: "InvoiceConfig",
  components: { Confirm },
  data() {
    return {
      contactName: "",
      contactEmail: "",
      contactPhone: "",
      ticName: "",
      ticAddress: "",
      ticPhone: "",
      ticSiret: "",
      vatNumber: "",
      iban: "",
      bic: "",
      paiementDeadline: 45,
      vatUsed: false,
      vatValue: "",
      invoicePattern: "%annee% - %increment%",
      invoiceConditions: "",
      invoiceSpace: "",
      invoicePatternExample: "",
      invoiceTitle: "Contrat de partenariat",
      pdf: null,
      apiUrl: process.env.VUE_APP_API_URL,
      contactFirstName: "",
      ticPostalCode: "",
      ticCity: "",
      incrementMissing: false,
      saved: false,
      accountInvoice: null,
      firstConfigMissingFieldsModal: false,
    }
  },
  methods: {
    setVatValue() {
      if (this.vatUsed === true) {
        this.vatValue = "20"
      } else {
        this.vatValue = ""
      }
    },
    saveConfig() {
      this.$refs.confirm.open("Information",
        "Après confirmation, ces paramètres seront effectifs pour chaque facture nouvellement générée. ",
        { color: "red", backgroundTitle: "primary", confirmColor: "primary" }).then((confirm) => {
        if (confirm) {
          let payload = {
            accountId: this.account.id,
            contactName: this.contactName,
            contactFirstName: this.contactFirstName,
            contactEmail: this.contactEmail,
            contactPhone: this.contactPhone,
            ticName: this.ticName,
            ticAddress: this.ticAddress,
            ticPostalCode: this.ticPostalCode,
            ticCity: this.ticCity,
            ticPhone: this.ticPhone,
            ticSiret: this.ticSiret,
            vatNumber: this.vatNumber,
            iban: this.iban,
            bic: this.bic,
            paiementDeadline: parseInt(this.paiementDeadline),
            // vatUsed: this.vatUsed,
            // vatValue: this.vatValue,
            invoicePattern: this.invoicePattern,
            invoiceConditions: this.invoiceConditions,
            invoiceSpace: this.invoiceSpace,
            invoiceTitle: this.invoiceTitle,
          }

          this.$global.loading = true

          this.$http.post("auth/invoice/create", payload).then(() => {
            this.$global.loading = false

            this.saved = true
            this.getConfig()
          })
        }
      })
    },
    getConfig: _.debounce(function() {

      this.$http.get("auth/invoice/" + this.account.id).then(res => {
        this.code = 200

        this.accountInvoice = res.body.data.cadhAccountInvoice

        this.vatUsed = res.body.data.priceHT

        this.setVatValue()

        if(this.accountInvoice) {
          this.contactName = res.body.data.cadhAccountInvoice.contact_name
          this.contactFirstName = res.body.data.cadhAccountInvoice.contact_first_name
          this.contactEmail = res.body.data.cadhAccountInvoice.contact_email
          this.contactPhone = res.body.data.cadhAccountInvoice.contact_phone
          this.ticName = res.body.data.cadhAccountInvoice.tic_name
          this.ticAddress = res.body.data.cadhAccountInvoice.tic_address
          this.ticPostalCode = res.body.data.cadhAccountInvoice.tic_postal_code
          this.ticCity = res.body.data.cadhAccountInvoice.tic_city
          this.ticPhone = res.body.data.cadhAccountInvoice.tic_phone
          this.ticSiret = res.body.data.cadhAccountInvoice.tic_siret
          this.vatNumber = res.body.data.cadhAccountInvoice.vat_number
          this.iban = res.body.data.cadhAccountInvoice.iban
          this.bic = res.body.data.cadhAccountInvoice.bic
          this.paiementDeadline = res.body.data.cadhAccountInvoice.paiement_deadline
          // this.vatUsed = res.body.data.cadhAccountInvoice.vat_used
          // this.vatValue = res.body.data.cadhAccountInvoice.vat_value
          this.invoicePattern = res.body.data.cadhAccountInvoice.invoice_pattern
          this.invoiceConditions = res.body.data.cadhAccountInvoice.invoice_conditions
          this.invoiceSpace = res.body.data.cadhAccountInvoice.invoice_space
          this.invoiceTitle = res.body.data.cadhAccountInvoice.invoice_title
        }
      })

      this.generateInvoicePatternExample()
    }, 500),
    generateInvoicePatternExample: _.debounce(function() {
      let currentTime = new Date()
      this.incrementMissing = false

      this.invoicePatternExample = this.invoicePattern.replaceAll("%increment%", "1").replaceAll(
        "%annee%", currentTime.getFullYear().toString()).replaceAll("%mois%",
        ("0" + (currentTime.getMonth() + 1).toString()).slice(-2)).replaceAll("%jour%", currentTime.getDate().toString())

      if(!this.invoicePattern.includes('%increment%')) {
        this.incrementMissing = true
      }
    }, 600),
    prepareSaveConfig() {
      if (!this.requiredFieldsMissing) {
        this.firstConfigMissingFieldsModal = true
      } else {
        this.saveConfig()
      }
    }
  },
  computed: {
    ...mapState("account", ["account"]),
    requiredFieldsMissing () {
      return !(this.incrementMissing || (this.vatUsed && this.vatValue === '') || this.invoiceTitle === '' ||
        this.ticName === '' || this.ticAddress === '' || this.ticPostalCode === '' || this.ticCity === '');
    }
  },
  created() {
    this.getConfig()
  },
}
</script>
